import {useQuery} from 'react-query';
import RefreshCheckApi from '../../../../communication_system/axios_apis/refresh_check/refresh_check_api';

const PAGE_SIZE = 4;
const DEFAULT_PATH = '/v2/dashboard/';
const VARIANT_PATH_MAP = {
    photoAuth: 'photo',
    'report-member': 'report/member',
    'report-content': 'report/content',
    'approve-gathering': 'gathering/approve',
    'approve-join': 'gathering/approve/join',
    'gathering-account': 'gathering/account',
    order: 'product/order',
};

/**
 *
 * @param {*} variant - photoAuth,report-member,report-content,'approve-gathering','approve-join','gathering-account','order'
 * @param {*} page - page number
 * @returns data for management detail page
 */
export const useManagementsDetail = (variant = 'report-content', page = 1) => {
    const path = DEFAULT_PATH + VARIANT_PATH_MAP[variant];

    return useQuery({
        queryKey: [variant, page],
        queryFn: async () => {
            const response = await RefreshCheckApi.get(path, { params: { page: page, size: PAGE_SIZE } });
            if (!response.data.ok) {
                throw new Error('Network response was not ok');
            }
            return response.data;
        },
        staleTime: 5 * 60 * 1000,
        cacheTime: 60 * 60 * 1000,
    });
};
